module.exports = __webpack_public_path__ + "assets/img/bg-button.8c35ed5b.png";